// import { helpers } from 'vuelidate/lib/validators'

import moment from 'moment/src/moment'

const todayIsBetweenDates = (startDate, endDate) => {
  const now = Date.now()

  // Startdatum und Enddatum in Millisekunden umrechnen
  const startDateMs = startDate ? startDate * 1000 : null
  const endDateMs = endDate ? endDate * 1000 : null

  // Wenn Datum nicht gesetzt, gilt es als aktiv
  const hasStarted = startDateMs ? now >= startDateMs : true
  const hasNotEnded = endDateMs ? now <= endDateMs : true

  return hasStarted && hasNotEnded
}

const validDateFormat = (dateString) => {
  if (dateString == null) {
    return false
  }
  return /^\d{2}\.\d{2}\.\d{4}$/.test(dateString.replace(/\u200e/g, ''))
}

const validDateFormatOnlyForNonEmpty = (dateString) => {
  if (dateString == null || dateString === '') {
    return true
  }
  return /^\d{2}\.\d{2}\.\d{4}$/.test(dateString.replace(/\u200e/g, ''))
}

const validDate = (dateString) => {
  return moment(dateString, 'DD.MM.YYYY').isValid()
}

const validAge = (dateString) => {
  const today = moment(new Date(), 'DD.MM.YYYY')
  const birthday = moment(dateString, 'DD.MM.YYYY')
  today.subtract(18, 'years')
  return (today.diff(birthday) >= 0)
}

const validGivenAge = (dateString, givenAge) => {
  const today = moment(new Date(), 'DD.MM.YYYY')
  const birthday = moment(dateString, 'DD.MM.YYYY')
  today.subtract(givenAge, 'years')
  return (today.diff(birthday) >= 0)
}

// TODO Namensgebung irreführend
const validDatePeriod = (daysOfPeriod) => (dateString) => {
  const today = moment(new Date(), 'DD.MM.YYYY')
  const dayToCheck = moment(dateString, 'DD.MM.YYYY')
  const minDay = today.subtract(daysOfPeriod + 1, 'days')
  return (dayToCheck.isAfter(minDay))
}

const isAfter = (before, after) => {
  const dtBefore = moment(before, 'DD.MM.YYYY')
  const dtAfter = moment(after, 'DD.MM.YYYY')
  return (dtAfter.isAfter(dtBefore))
}

const isSameOrAfter = (before, after) => {
  const dtBefore = moment(before, 'DD.MM.YYYY')
  const dtAfter = moment(after, 'DD.MM.YYYY')
  return (dtAfter.isSameOrAfter(dtBefore))
}
const isPermanentDate = (date) => {
  const today = new Date()
  const eightyYearsInMilliSec = 80 * 1000 * 60 * 60 * 24 * 365
  return (Date.parse(date) - Date.parse(today)) >= eightyYearsInMilliSec
}
export default {
  methods: {
    // checks the parsed value to be valid
    validDate,
    // checks for the general format xx.xx.xxxx
    validDateFormat,
    validDateFormatOnlyForNonEmpty,
    // check for age is over 18 years
    validAge,
    validGivenAge,
    // checks if date in the past is >= daysOfPeriod days ago
    validDatePeriod,
    isAfter,
    isSameOrAfter,
    isPermanentDate,
    todayIsBetweenDates
  }
}

export {
  // checks the parsed value to be valid
  validDate,
  // checks for the general format xx.xx.xxxx
  validDateFormat,
  validDateFormatOnlyForNonEmpty,
  // check for age is over 18 years
  validAge,
  validGivenAge,
  // checks if date in the past is >= daysOfPeriod days ago
  validDatePeriod,
  isAfter,
  isSameOrAfter
}
